<template>
  <span class="d-inline" v-if="isDisplay" v-cloak>
    <div class="d-flex align-center">
      <a href="#none" @click.prevent="movePayment" class="eAppVersion" v-cloak>
        <div v-if="$store.state.mode === AUTH_SERVICE.APP_MODE.ANY" v-cloak>
          <span>사용 기간 만료되었습니다.</span>
        </div>
        <div v-else>
          <span v-if="$store.state.mode === AUTH_SERVICE.APP_MODE.BASIC" v-cloak
            >서비스 사용중</span
          >
          <span v-else>서비스 사용중</span>
          <span v-cloak>{{
            setExpiresDays(this.$store.state.expires_at)
          }}</span>
        </div>
      </a>
      <template style="margin-top:10px;">
        <div class="text-center ml-4">
          <v-menu offset-y max-width="480">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-apps</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/10777')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/survey_icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      맞춤 질문 추천 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    고객 취향에 맞춘 개인화 상품 추천서비스.<br />
                    고객이 선택한 답변에 따라 상품을 추천하므로<br />
                    구매율과 만족도를 높여줍니다.<br />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <!--
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/8510')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/point_sales_service.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      포인트 판매 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    포인트를 판매하고 적립금을 자동 지급하는 서비스.<br />
                    회원들은 적립금 혜택으로 만족하고 남은 적립금은<br />
                    재방문/재구매를 이끌어줍니다.
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              -->
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/6711')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/membership.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      유료 멤버십 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >쇼핑몰 회원들에게 제공되는 차별화된 서비스.<br />
                    쇼핑몰 구독시대에 필요한 특별한 서비스로<br />
                    고객 이탈을 막고 충성고객을
                    확보하세요.</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </div>
  </span>
</template>
<style scoped>
[v-clock] {
  display: none;
}
.eAppVersion {
  color: white;
  text-decoration: none;
}
.eAppVersion:hover {
  text-decoration: underline;
}
</style>
<script>
import { AUTH_SERVICE } from "@/datas/authservice";

export default {
  data: () => ({
    AUTH_SERVICE,
    versionText: "D - day",
    isDisplay: false,
  }),
  methods: {
    setExpiresDays: function(expiresDate) {
      if (expiresDate !== null) {
        let toDay = new Date();
        let expDate = expiresDate.substr(0, 10);
        let expParts = expDate.split("-");
        var endDate = new Date(expParts[0], expParts[1] - 1, expParts[2]);
        var gap = toDay.getTime() - endDate.getTime();
        var result = Math.floor(gap / (1000 * 60 * 60 * 24)) * -1;
        return ` (D-day ${result})`;
      }
    },
    movePayment: function() {
      this.$router.push({
        path: `/authservice/${this.$store.state.mallId}/payment`,
      });
    },
    cafe24SiteShow: function(url) {
      window.open(url, "_blank");
    },
  },
  mounted: function() {
    this.$nextTick(function() {
      setTimeout(() => {
        this.isDisplay = true;
      }, 500);
    });
  },
};
</script>
